export const selectProductsFindMeLastClickTime = (state, defaultValue = {}) =>
  state.clickTracker.productsFindMeClickTimes || defaultValue;
